import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Medal, Award } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const Leaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [currentUserRank, setCurrentUserRank] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  const fetchLeaderboard = async () => {
    try {
      const response = await axios.get(`${API_URL}/gamification/leaderboard?limit=5`);
      setLeaderboard(response.data.leaderboard);
      setCurrentUserRank(response.data.current_user_rank);
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
    } finally {
      setLoading(false);
    }
  };

  const getRankIcon = (rank) => {
    switch (rank) {
      case 1:
        return <Trophy className="w-5 h-5 text-yellow-500" />;
      case 2:
        return <Medal className="w-5 h-5 text-slate-400" />;
      case 3:
        return <Award className="w-5 h-5 text-amber-600" />;
      default:
        return <span className="w-5 h-5 flex items-center justify-center text-sm font-bold text-slate-400">{rank}</span>;
    }
  };

  const getRankBg = (rank) => {
    switch (rank) {
      case 1:
        return 'bg-gradient-to-r from-yellow-50 to-amber-50 border-yellow-200';
      case 2:
        return 'bg-gradient-to-r from-slate-50 to-slate-100 border-slate-200';
      case 3:
        return 'bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200';
      default:
        return 'bg-white border-slate-100';
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-6 animate-pulse">
        <div className="h-6 bg-slate-200 rounded w-1/3 mb-4"></div>
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-12 bg-slate-100 rounded mb-2"></div>
        ))}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm">
      <div className="p-4 border-b border-slate-100">
        <h3 className="font-semibold text-slate-900 flex items-center gap-2">
          <Trophy className="w-5 h-5 text-yellow-500" />
          Tabla de Clasificación
        </h3>
      </div>
      <div className="divide-y divide-slate-100">
        {leaderboard.length === 0 ? (
          <div className="p-6 text-center text-slate-500">
            <p>No hay datos de clasificación todavía.</p>
            <p className="text-sm mt-1">¡Completa lecciones para aparecer aquí!</p>
          </div>
        ) : (
          <>
            {leaderboard.map((entry) => (
              <div
                key={entry.user_id}
                className={`p-3 flex items-center gap-3 border-l-4 ${getRankBg(entry.rank)}`}
              >
                <div className="flex-shrink-0">
                  {getRankIcon(entry.rank)}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-slate-900 truncate">{entry.user_name}</p>
                  <p className="text-xs text-slate-500">
                    Nivel {entry.level} • {entry.badges_count} insignias
                  </p>
                </div>
                <div className="flex-shrink-0 text-right">
                  <p className="font-bold text-indigo-600">{entry.total_points}</p>
                  <p className="text-xs text-slate-400">XP</p>
                </div>
              </div>
            ))}
            
            {/* Tu posición si no estás en el top */}
            {currentUserRank && (
              <>
                <div className="px-3 py-2 bg-slate-50 text-center text-xs text-slate-400">
                  • • •
                </div>
                <div className="p-3 flex items-center gap-3 bg-indigo-50 border-l-4 border-indigo-400">
                  <div className="flex-shrink-0">
                    <span className="w-5 h-5 flex items-center justify-center text-sm font-bold text-indigo-600">
                      {currentUserRank.rank}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-indigo-900 truncate">
                      {currentUserRank.user_name} <span className="text-xs text-indigo-500">(Tú)</span>
                    </p>
                    <p className="text-xs text-indigo-600">
                      Nivel {currentUserRank.level} • {currentUserRank.badges_count} insignias
                    </p>
                  </div>
                  <div className="flex-shrink-0 text-right">
                    <p className="font-bold text-indigo-600">{currentUserRank.total_points}</p>
                    <p className="text-xs text-indigo-400">XP</p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Leaderboard;
